import React from 'react'
import { Switch, BrowserRouter, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './bootstrap.css'
import './font.css'
import './App.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import AuthContextProvider from './components/common/contextProviders/authContextProvider'
import MigrantContextProvider from './components/common/contextProviders/migrantContextProvider'
import VendorContextProvider from './components/common/contextProviders/vendorContextProvider'
import PrivateRoute from './components/common/routes/privateRoute'
import SignInRoute from './components/common/routes/signInRoute'
import NotFound from './components/common/routes/notFound'
import MigrantHome from './components/migrant/index'
import MigrantDashboard from './components/migrant/dashboard/index'
import MigrantProfile from './components/migrant/profile/index'
import MigrantEditProfile from './components/migrant/profile/edit'
import MigrantLogin from './components/migrant/onboarding/index'
import MigrantLanguage from './components/migrant/onboarding/language'
import MigrantHomeCountry from './components/migrant/onboarding/homecountry'
import MigrantWorkCountry from './components/migrant/onboarding/workcountry'
import VendorInviteSignup from './components/vendor/onboarding/inviteSignup'
import VendorLogin from './components/vendor/onboarding/index'
import VendorRouter from './components/vendor/index'
import Shop from './components/migrant/shop/index'
import YourOrders from './components/migrant/orders/index'
import AddRecipient from './components/migrant/recipients/addRecipient'
import EditRecipient from './components/migrant/recipients/editRecipient'
import YourOrderDetail from './components/migrant/orders/orderDetail'
import TrackOrder from './components/migrant/orders/trackOrder'
import Contacts from './components/migrant/contacts'
import PrivacyPolicy from './components/common/staticPages/privacyPolicy'
import RefundPolicy from './components/common/staticPages/refundPolicy'
import TermsOfService from './components/common/staticPages/termsOfService'
import Wallet from './components/migrant/wallet'
import PayNextInstallment from './components/migrant/orders/payNextInstallment'
import Jobs from './components/migrant/jobs'

// Routes
function App() {
  return (
    <MigrantContextProvider>
      <VendorContextProvider>
        <AuthContextProvider>
          <ToastContainer />
          <BrowserRouter>
            <Switch>
              /* Migrant Routes */
              <Route exact path="/" component={MigrantHome} />
              <Route
                path="/policies/privacy-policy"
                component={PrivacyPolicy}
              />
              <Route path="/policies/refund-policy" component={RefundPolicy} />
              <Route
                path="/policies/terms-of-service"
                component={TermsOfService}
              />
              <SignInRoute path="/login" component={MigrantLogin} />
              <PrivateRoute
                path="/onboarding/homecountry"
                component={MigrantHomeCountry}
              />
              <PrivateRoute
                path="/onboarding/workcountry"
                component={MigrantWorkCountry}
              />
              <Route path="/onboarding/language" component={MigrantLanguage} />
              <PrivateRoute path="/dashboard" component={MigrantDashboard} />
              <PrivateRoute path="/profile" component={MigrantProfile} />
              <PrivateRoute
                path="/editprofile"
                component={MigrantEditProfile}
              />
              <Route path="/shop" component={Shop} />
              <PrivateRoute
                path="/orders/:orderId/:orderItemId"
                component={TrackOrder}
              />
              <PrivateRoute
                path="/orders/:orderId"
                component={YourOrderDetail}
              />
              <PrivateRoute path="/orders" component={YourOrders} />
              <PrivateRoute path="/recipients/add" component={AddRecipient} />
              <PrivateRoute
                path="/recipients/:recipientId"
                component={EditRecipient}
              />
              <PrivateRoute path="/contacts" component={Contacts} />
              <PrivateRoute path="/wallet" component={Wallet} />
              <PrivateRoute
                path="/installments/:installmentId/pay/:part"
                component={PayNextInstallment}
              />
              <Route path="/jobs" component={Jobs} />
              /* Vendor Routes */
              <SignInRoute path="/vendor/login" component={VendorLogin} />
              <SignInRoute
                path="/vendor/signup/:email/:token"
                component={VendorInviteSignup}
              />
              <Route path="/vendor" component={VendorRouter} />
              /* Common Routes */
              <Route path="*" component={NotFound} />
            </Switch>
          </BrowserRouter>
        </AuthContextProvider>
      </VendorContextProvider>
    </MigrantContextProvider>
  )
}

export default App
